function getArrayTrueElementsCount(arr) {
  return arr.filter((item) => Boolean(item)).length;
}

export default getArrayTrueElementsCount;
